import {THEME} from '@wandb/weave/common/css/color.styles';
import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

import {Icon} from '../Icon';

export const ColumnHeader = styled.div`
  display: flex;
  align-items: stretch;
  white-space: nowrap;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  .column-actions-trigger {
    visibility: hidden;
  }
  :hover .column-actions-trigger {
    visibility: visible;
  }
  .column-actions-trigger:hover {
    color: light-dark(${globals.primary}, var(--teal-450));
  }
`;
ColumnHeader.displayName = 'S.ColumnHeader';

export const ColumnName = styled.div`
  cursor: pointer;
  padding: 4px 4px 4px 1em;
  flex: 1 1 auto;
  :hover {
    color: light-dark(${globals.primary}, var(--teal-450));
  }
  overflow: hidden;
`;
ColumnName.displayName = 'S.ColumnName';

export const ColumnNameText = styled.span`
  width: 100%;
  height: 100%;
  text-align: center;
`;
ColumnNameText.displayName = 'S.ColumnNameText';

export const IndexColumnVal = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 8px;
  :hover {
    color: light-dark(${globals.primary}, var(--teal-450));
    background-color: ${THEME.bgHover};
  }
`;
IndexColumnVal.displayName = 'S.IndexColumnVal';

export const IndexColumnText = styled.div`
  text-align: center;
  flex: 1 1 auto;
  height: 20px;
  display: flex;
  align-content: space-around;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
`;
IndexColumnText.displayName = 'S.IndexColumnText';

export const IndexColumnDrag = styled.div`
  flex: 0 0 auto;
  width: 100%;
  height: 2px;
  background-color: light-dark(#eee, var(--moon-800));
  cursor: pointer;
  :hover {
    cursor: row-resize;
    background-color: rgb(51, 153, 255);
  }
  :highlight {
    position: absolute;
    background: rgb(51, 153, 255);
  }
`;
IndexColumnDrag.displayName = 'S.IndexColumnDrag';

export const FilterIcon: typeof Icon = styled(Icon)`
  cursor: pointer;
  color: light-dark(${globals.primary}, var(--teal-450));
  :hover {
    background-color: light-dark(#eee, var(--moon-800));
    border-radius: 2px;
  }
`;

export const ColumnAction = styled.div<{isHovered?: boolean}>`
  cursor: pointer;
  height: 100%;
  background-color: transparent;
`;
ColumnAction.displayName = 'S.ColumnAction';

export const ColumnActionContainer = styled.div<{isHovered?: boolean}>`
  display: flex;
  padding: 5px 0px 0px 0px;
  font-size: 20px;
  flex: 0 0 auto;
  height: 100%;

  :hover {
    background-color: ${THEME.bgHover};
  }
`;
ColumnActionContainer.displayName = 'S.ColumnActionContainer';

export const TableAction = styled.div<{
  highlight?: boolean;
}>`
  cursor: pointer;
  padding: 5px 4px 0px 4px;
  flex: 0 0 auto;
  height: 100%;
  width: 100%;
  color: ${props =>
    props.highlight ? 'light-dark(white, var(--moon-900))' : 'inherit'};
  background-color: ${props =>
    props.highlight
      ? 'light-dark(rgb(3, 183, 206), var(--teal-450))'
      : 'inherit'};
  :hover {
    color: light-dark(${globals.primary}, var(--teal-450));
    background-color: ${props =>
      props.highlight
        ? 'light-dark(rgb(3, 183, 206), var(--teal-450))'
        : THEME.bgHover};
  }
  box-shadow: light-dark(#f8f8f8, var(--moon-850)) -2px 0px 8px 4px;
  display: inline-flex;
  justify-content: center;
`;
TableAction.displayName = 'S.TableAction';

export const ControlIcon: typeof Icon = styled(Icon)`
  cursor: pointer;
  color: light-dark(${globals.primary}, var(--teal-450));
  margin: auto;
`;

export const SortIcon: typeof Icon = styled(Icon)`
  cursor: pointer;
  color: light-dark(#afafaf, var(--moon-450));
  :hover {
    background-color: light-dark(#eee, var(--moon-800));
    border-radius: 2px;
  }
`;

export const ColumnEditor = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 80dvh;
`;

export const ColumnEditorHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding-bottom: 12px;
  font-weight: 600;
`;

export const ColumnEditorBody = styled.div`
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
`;

export const ColumnEditorFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  padding-top: 12px;
  border-top: 1px solid ${THEME.border};
`;

export const ColumnEditorSection = styled.div`
  margin-bottom: 24px;
`;
ColumnEditorSection.displayName = 'S.ColumnEditorSection';

export const ColumnEditorSectionLabel = styled.div`
  margin-bottom: 8px;
  font-weight: 600;
`;
ColumnEditorSectionLabel.displayName = 'S.ColumnEditorSectionLabel';

export const ColumnEditorColumnName = styled.div`
  display: flex;
  align-items: center;
  color: light-dark(#aaaaaa, var(--moon-400));
`;
ColumnEditorColumnName.displayName = 'S.ColumnEditorColumnName';

export const ColumnEditorFieldLabel = styled.div`
  margin-right: 8px;
`;
ColumnEditorFieldLabel.displayName = 'S.ColumnEditorFieldLabel';

export const AssignmentWrapper = styled.div`
  display: flex;
  align-items: center;
`;
AssignmentWrapper.displayName = 'S.AssignmentWrapper';

export const PanelNameEditor = styled.div`
  margin-bottom: 12px;
`;
PanelNameEditor.displayName = 'S.PanelNameEditor';

export const PanelSettings = styled.div`
  padding: 8px 24px;
  background-color: light-dark(#f6f6f6, var(--moon-850));
  border-radius: 4px;
  // min-width: 600px;
  :empty {
    padding: 0;
  }
  overflow: visible;
  // max-height: 300px;
`;
PanelSettings.displayName = 'S.PanelSettings';

export const CellWrapper = styled.div`
  width: 100%;
  height: 100%;
  :hover {
    background-color: ${THEME.bgHover};
  }
`;
CellWrapper.displayName = 'S.CellWrapper';

export const IndexCellCheckboxWrapper = styled.div<{isSelected: boolean}>`
  ${({isSelected}) => (isSelected ? '' : 'visibility: hidden;')}
  margin-right: 8px;
`;
IndexCellCheckboxWrapper.displayName = 'S.IndexCellCheckboxWrapper';
